import { createReducer, on, Action } from "@ngrx/store";
import { LicenseEntityJson } from "@youm-front/license/domain";
import { LicenseActions } from "../actions";

export const LICENSE_FEATURE_KEY = "license";

export interface LicenseState {
  license: null | LicenseEntityJson;
  isLoading: boolean;
}

export const initialLicenseState: LicenseState = {
  license: null,
  isLoading: false
};

const reducer = createReducer(
  initialLicenseState,
  on(LicenseActions.loadLicense, (state) => ({
    ...state,
    isLoading: true
  })),
  on(LicenseActions.loadLicenseSuccess, (state, { license }) => ({
    ...state,
    license: license.toJSON(),
    isLoading: false
  })),
  on(LicenseActions.loadLicenseFailure, (state) => ({
    ...state,
    isLoading: false
  }))
);

export function licenseReducer(
  state: LicenseState | undefined,
  action: Action
) {
  return reducer(state, action);
}
